import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import "./LoginInDialog.scss"
import Axios from 'middleware/axiosInstance';

const LoginInDialog = () => {

    const [userName, setUserName] = useState()
    const [password, setPassword] = useState()
    const [open, setOpen] = useState(true);

    useEffect(() => {
        // remove user information from localstorage(if close app and open again, redirect to login page)
        localStorage.removeItem('token');
    }, []);

    

    const closeDialog = () => {
        setOpen(false);
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        // check internet connection
        if (!navigator.onLine) {
            alert("به اینترنت متصل نمی باشید")
        }
        else {
            try {
                const apiURL = process.env.REACT_APP_BASE_API_URL
                const apiRoute = "login"
                await Axios.post(apiRoute, {
                    "phone": userName,
                    "password": password
                })
                    .then((response) => {
                        localStorage.setItem("name", response.data.data.name);
                        localStorage.setItem("token", response.data.data.api_token);
                        localStorage.setItem("post", response.data.data.post);
                        closeDialog()
                    })
                    .catch(err => {
                        alert("نام کاربری و رمز عبور را چک فرمایید")
                    })
            } catch (e) {
                alert(e.message);
            }
        }
    }


    return (
        <div>
            
            <Dialog
                open={open}
            >
                <DialogTitle>نیاز به ورود مجدد</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        احراز هویت شما منقضی شده است، خواهشمند است مجددا به سامانه وارد شوید
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="username"
                        label="نام کاربری"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={e => setUserName(e.target.value)}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        id="password"
                        label="رمز عبور"
                        type="password"
                        fullWidth
                        variant="standard"
                        onChange={e => setPassword(e.target.value)}
                    />
                </DialogContent>
                <DialogActions >
                    <Button variant="contained" onClick={handleLogin}>ورود</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default LoginInDialog